import type { IconData } from '@stacksjs/iconify-core'

export const headphones: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M448 216h-48v-32c0-79.4-64.6-144-144-144s-144 64.6-144 144v32H64a48.055 48.055 0 0 0-48 48v128a48.055 48.055 0 0 0 48 48h48a32.036 32.036 0 0 0 32-32V184a112 112 0 0 1 224 0v224a32.036 32.036 0 0 0 32 32h48a48.055 48.055 0 0 0 48-48V264a48.055 48.055 0 0 0-48-48M112 408H64a16.02 16.02 0 0 1-16-16V264a16.02 16.02 0 0 1 16-16h48v56h.008l.012 104Zm352-16a16.02 16.02 0 0 1-16 16h-48V248h48a16.02 16.02 0 0 1 16 16Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default headphones
